export const GET_POSTS = 'news/GET_POSTS';



// WEBPACK FOOTER //
// ./src/redux/Posts/constants.js